import Otp from 'components/otp/otp';
import { useEffect, useState } from 'react';

// Todo make this component usable in signup
export function OtpComponent({
  otp,
  setOtp,
  username,
  backCallback,
  isLoading,
  state,
  showResendMess,
  sendOtpAction,
  setResendAction,
  submissionCallback,
  resendCallback,
  setShowResendMess,
}) {
  //   const [isVerified, setIsVerified] = useState(false);
  const [showResend, setShowResend] = useState(false);
  const [timeLeft, setTimeLeft] = useState(30);
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowResend(true);
    }, 30000);
    return () => clearTimeout(timer);
  }, [state]);

  // countdown timer
  useEffect(() => {
    const timer = setInterval(() => {
      if (timeLeft > 1) {
        setTimeLeft(timeLeft - 1);
      } else setShowResend(true);
    }, 1000);
    return () => clearInterval(timer);
  }, [timeLeft]);
  return (
    <div>
      <>
        <div className="pt-3 text-gray-700 font-roboto info">
          Kindly Enter The OTP Received on Your Mobile.
        </div>
        <div className={'pt-2 pb-5'}>
          {username?.toLowerCase()} :{' '}
          <a
            className={'cursor-pointer'}
            onClick={() => {
              setOtp('');
              backCallback && backCallback();
            }}
          >
            Edit
          </a>
        </div>
      </>
      <Otp code={otp} setCode={setOtp}></Otp>
      {!showResend ? (
        <div className="mt-5 flex justify-between mb-5 w-full">
          <div className="text-gray-700 font-roboto info">
            Resend OTP in <span className="text-red-500 font-bold">{timeLeft}</span> seconds
          </div>
        </div>
      ) : (
        <div className="mt-5 flex justify-between mb-5 w-full">
          <div className="text-gray-700 font-roboto info">
            <a
              onClick={() => {
                setResendAction && setResendAction(true);
                setShowResend(false);
                setShowResendMess && setShowResendMess(true);
                resendCallback && resendCallback(username);
                setTimeLeft(30);
                // sendOtpAction && sendOtpAction(email);
              }}
              className="cursor-pointer"
            >
              Resend Code
            </a>
          </div>
        </div>
      )}
      <div className={`${state === 'success' ? 'text-green-500' : 'text-red-500'} my-3`}>
        {state === 'success' ? (
          showResendMess ? (
            'OTP resent Successfully. Please check your email for the OTP.'
          ) : (
            'OTP Sent Successfully. Please check your email for the OTP.'
          )
        ) : state === 'exists' ? (
          <span>
            User Already Exists!{' '}
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                backCallback && backCallback();
              }}
            >
              go Back
            </a>
          </span>
        ) : state === 'error' ? (
          <span>
            Error Occured!{' '}
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                backCallback && backCallback();
              }}
            >
              go Back
            </a>
          </span>
        ) : state === 'invalidOTP' ? (
          'Invalid OTP'
        ) : (
          ''
        )}
      </div>
      {/* <div className="flex justify-between w-full">
        <button
          className="flex justify-center items-center reg-btn-dark w-full my-2 rounded-lg px-10 py-2 text-white"
          type="button"
          onClick={() => {
            submissionCallback && submissionCallback();
          }}
        >
          Submit and Verify
          {isLoading ? <img src={Rotate} className="ml-2 w-4 h-4 color-white animate-spin" /> : ''}
        </button>
      </div> */}
    </div>
  );
}
